import {
  BaseError,
  createErrorBuilder,
} from '@wix/public-editor-platform-errors';

export enum PanelsErrorCode {
  EmptyApplicationDefId = 'EmptyApplicationDefId',
}

class PanelsError extends BaseError<PanelsErrorCode> {
  constructor(message: string, code: PanelsErrorCode) {
    super(message, code, 'PanelsError Private API Error');
  }
}

export const createPanelsError = createErrorBuilder<
  PanelsErrorCode,
  PanelsError
>(PanelsError);
